import React, { useRef } from 'react';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { EqualisationFormValues } from './FormWrapper';
import EqualisationRealisationAllocationsForm from './EqualisationRealisationAllocationsForm';
import TabsPanel from 'further-ui/components/TabsPanel';
import EqualisationAllocationsForm from './EqualisationAllocationsForm';
import Divider from '@mui/material/Divider';

interface ActionCardProps {
  action: EqualisationFormValues['actions'][number] & {
    originalRealisationAllocations?: EqualisationFormValues['actions'][number]['linkedActions'][number]['originalRealisationAllocations'];
    newRealisationAllocations?: EqualisationFormValues['actions'][number]['linkedActions'][number]['newRealisationAllocations'];
  };
  actionIndex: number;
  linkedActionIndex?: number;
  baseCurrency: CurrencyCode;
}

const ActionCard: React.FC<ActionCardProps> = ({
  action,
  actionIndex,
  baseCurrency,
  linkedActionIndex,
}) => {
  const frozenOriginalAllocations = useRef(action.originalAllocations);

  return (
    <>
      <Divider />
      <TabsPanel
        disableFullWidth
        tabs={[
          {
            label: 'New allocation',
            key: 'newAllocation',
            content:
              action.newAllocations.length > 0 ? (
                <EqualisationAllocationsForm
                  fields={action.newAllocations}
                  inputAmountLcy={action.totalAmountLcy}
                  isNotEditable={false}
                  actionIndex={actionIndex}
                  allocationRule={action.allocationRule}
                  allocationType="newAllocations"
                  linkedActionIndex={linkedActionIndex}
                  transactionCurrency={baseCurrency}
                />
              ) : (
                <EqualisationRealisationAllocationsForm
                  transactionCurrency={baseCurrency}
                  isNotEditable={false}
                  actionIndex={actionIndex}
                  allocationType="newRealisationAllocations"
                  allocationRule={action.allocationRule}
                  linkedActionIndex={linkedActionIndex}
                />
              ),
          },
          {
            label: 'Original allocation',
            key: 'originalAllocation',
            content:
              frozenOriginalAllocations.current &&
              frozenOriginalAllocations.current.length > 0 ? (
                <EqualisationAllocationsForm
                  fields={frozenOriginalAllocations.current}
                  inputAmountLcy={action.totalAmountLcy}
                  isNotEditable={true}
                  actionIndex={actionIndex}
                  allocationRule={action.allocationRule}
                  allocationType="originalAllocations"
                  linkedActionIndex={linkedActionIndex}
                  transactionCurrency={baseCurrency}
                />
              ) : (
                <EqualisationRealisationAllocationsForm
                  transactionCurrency={baseCurrency}
                  allocationRule={action.allocationRule}
                  isNotEditable={true}
                  actionIndex={actionIndex}
                  allocationType="originalRealisationAllocations"
                  linkedActionIndex={linkedActionIndex}
                />
              ),
          },
        ]}
      />
      {action.linkedActions.map((linkedAction, linkedIndex) => (
        <ActionCard
          key={linkedIndex}
          action={{
            ...linkedAction,
            linkedActions: [],
            actionType: 'Linked action',
          }}
          actionIndex={actionIndex}
          linkedActionIndex={linkedIndex}
          baseCurrency={baseCurrency}
        />
      ))}
    </>
  );
};

export default ActionCard;
